<button [class]="buttonTypeClass" [class.w-100]="fullWidth" [disabled]="disabled" [type]="type" (click)="action.emit()">
  <div class="d-flex align-items-center justify-content-center" [class.wide]="wide">
    <i [class]="iconClass" *ngIf="icon"></i>
    <div [innerHTML]="buttonText"></div>
  </div>
</button>
